export default __webpack_public_path__ + "static/media/logo-android.ee246c51.svg";